import React, { useEffect, useRef, useState } from 'react';
import {
  func, bool, object,
} from 'prop-types';
import cookies from 'react-cookies';
import MuiModal from '@material-ui/core/Modal';
import {
  Typography, Box, Paper, useMediaQuery, makeStyles, IconButton, Icon,
} from '@material-ui/core';
import { AvonIcon } from '@avon/component-library';
import useTheme from '@material-ui/styles/useTheme';
import { InlineShareButtons, InlineFollowButtons } from 'sharethis-reactjs';
import copyClipboard from 'copy-to-clipboard';
import { useTracking } from '../../analytics/Analytics';
// import viber from './icons/viber.png';
import odnoklassnikiIcon from './icons/odnoklassniki.svg';
import vkIcon from './icons/vk.svg';
import tiktok from './icons/tiktok.svg';
import emailIcon from './icons/email.svg';
import viber from './icons/viber.svg';
import wizaz from './icons/wizaz.svg';
import { setProfileShared } from '../../utils/api/endpoints';

const useStyles = makeStyles(() => ({
  button1: {
    '& a': {
      textDecoration: 'none',
    },
  },
  url: {
    wordBreak: 'break-word',
  },
  inlineShareButtons: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > div': {
      marginTop: 8,
    },
    '& > div:first-child': {
      marginRight: 8,
    },
    '& div[data-network]': {
      display: 'inline-block!important',
    },
  },
  resetSocialMedias: {
    display: 'flex',
    marginLeft: 8,
  },
  styledIcon: {
    width: 44,
    height: 40,
    marginRight: 8,
    borderRadius: 4,
    background: '#bfbbbb',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: '0.2s',
    transform: 'translateY(0)',
    opacity: 1,
    '&:hover': {
      transform: 'translateY(-4px)',
      opacity: 0.8,
    },
  },
  styledImg: {
    width: 24,
    height: 24,
  },
  clipboardBox: {
    position: 'absolute',
    top: -60,
    right: -26,
    padding: 12,
    background: '#ffffff',
    borderRadius: '4px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(35, 57, 66, 0.21)',
    cursor: 'default',
    '&::before': {
      content: "''",
      position: 'absolute',
      bottom: -9,
      right: 32,
      zIndex: 10,
      borderTop: '6px solid #E4EDED',
      borderLeft: '5px solid transparent',
      borderRight: '5px solid transparent',
      width: 0,
      height: 0,
    },
    '&::after': {
      content: "''",
      position: 'absolute',
      bottom: -8,
      right: 32,
      zIndex: 10,
      borderTop: '6px solid #FFFFFF',
      borderLeft: '5px solid transparent',
      borderRight: '5px solid transparent',
      width: 0,
      height: 0,
    },
  },
  clipboardText: {
    fontSize: 14,
    lineHeight: '20px',
    color: '#546264',
    whiteSpace: 'nowrap',
    marginLeft: 6,
  },
}));

const copyIcon = color => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M17.9945 3.85074C17.9182 2.81588 17.0544 2 16 2H4L3.85074 2.00549C2.81588 2.08183 2 2.94564 2 4V16L2.00549 16.1493C2.08183 17.1841 2.94564 18 4 18V4H18L17.9945 3.85074ZM20 6H8C6.89543 6 6 6.89543 6 8V20C6 21.1046 6.89543 22 8 22H20C21.1046 22 22 21.1046 22 20V8C22 6.89543 21.1046 6 20 6ZM8 8H20V20H8V8Z" fill={color} />
  </svg>
);

const sortNames = ({ type: a }, { type: b }) => {
  if (a.match(/email/)) {
    return -1;
  }

  if (a.match(/phone/) && !b.match(/email/)) {
    return -1;
  }

  if (b.match(/email/)) {
    return 1;
  }

  return b > a ? -1 : 1;
};

const socialIcons = {
  email: {
    icon: emailIcon,
    prefix: 'mailto:',
  },
  odnoklassniki: {
    icon: odnoklassnikiIcon,
    prefix: 'https://ok.ru/',
  },

  vkontakte: {
    icon: vkIcon,
    prefix: 'https://vk.com/',
  },

  tiktok: {
    icon: tiktok,
    prefix: 'https://www.tiktok.com/@',
  },

  viber: {
    icon: viber,
    prefix: 'viber://add?number=',
  },

  wizaz: {
    icon: wizaz,
    prefix: 'https://wizaz.pl/forum/member.php?u=',
  },
};


const ShareModal = ({
  open,
  callApi,
  setShareOpen,
  slProfile,
  socialList,
  sharePRPInfo,
}) => {
  const theme = useTheme();
  const market = cookies.load('mrktCd');
  const language = cookies.load('langCd');
  const urlLast = slProfile.vanityName
    || (slProfile.suggestList && slProfile.suggestList[0]) || '';
  const { origin } = window.location;
  let API_URL = origin;
  if (market === 'JT') {
    if (origin.indexOf('arpqa.') !== -1) {
      API_URL = 'https://arpqa.avon.com';
    } else if (origin.indexOf('arpqaf.') !== -1) {
      API_URL = 'https://arpqaf.avon.com';
    } else if (origin.indexOf('arpqap.') !== -1) {
      API_URL = 'https://arpqap.avon.com';
    } else if (origin.indexOf('arp.') !== -1) {
      API_URL = 'https://arp.avon.com';
    }
  } else if (market === 'RU') {
    if (origin.indexOf('arp.') !== -1) {
      API_URL = 'https://reg.avon.ru';
    }
  }
  const urlPrefer = market === 'RU'
    ? `${API_URL}/prp/`
    : `${API_URL}/prp/${market}/${language}/`;
  const url = market === 'RU'
    ? `${API_URL}/prp/${urlLast}`
    : `${API_URL}/prp/${market}/${language}/${urlLast}`;

  const { orCopyLinkLabel, shareWithLabel, copiedToClipboardLabel } = sharePRPInfo || {};

  let inlineShareButtons = [];
  let inlineFollowButtons = [];
  let resetSocialMedias = [];
  const inlineFollowLinks = {};
  if (socialList) {
    const sorted = [...socialList].sort(sortNames);
    const socialMedias = sorted.filter(({ type }) => !type.match(/phone|location/));
    inlineShareButtons = socialMedias.filter(({ type }) => type && !type.match(/email/)).map(({ type }) => type);
    inlineFollowButtons = socialMedias.filter(({ type }) => !type.match(/blogger|delicious|digg|email|facebook|flipboard|google|linkedin|livejournal|mailru|meneame|messenger|oknoklassniki|pinterest|print|reddit|sharethis|sms|stumbleupon|tumblr|twitter|vk|wechat|weibo|whatsapp|xing|telegram/));
    inlineFollowButtons.forEach(({ type, link }) => {
      inlineFollowLinks[type] = link;
    });
    resetSocialMedias = sorted.filter(({ type }) => type.match(/email|odnoklassniki|vkontakte|tiktok|viber|wizaz/)).map((item) => {
      const { type } = item;
      // eslint-disable-next-line
      item.icon = <AvonIcon type={type} alt={`${type}-icon`} id={`social-item-${type}-icon`} color={theme.palette.colors.corePink} height="24px" width="24px" />;
      return item;
    });
  }
  const [, setTracking] = useTracking();

  const classes = useStyles();
  const isNotMobile = useMediaQuery(theme.breakpoints.up('sm'));


  useEffect(() => {
    const addGAForShareButton = (e) => {
      const { target } = e;
      const parentAttr = target.parentElement && target.parentElement.getAttribute('data-network');
      let socialName = target.getAttribute('data-network');
      if (target.tagName === 'IMG' && parentAttr) {
        socialName = parentAttr;
      }
      if (socialName) {
        setTracking({
          rep_id: sessionStorage.getItem('userId'),
          market,
          method: socialName,
        });
      }
    };
    document.addEventListener('click', addGAForShareButton, false);

    return () => {
      document.removeEventListener('click', addGAForShareButton, false);
    };
  }, [market, setTracking]);

  const updateShared = () => {
    const profileStr = sessionStorage.getItem('slProfile');
    if (profileStr) {
      const profile = JSON.parse(profileStr);
      if (profile.vanityName && profile.status === true) {
        try {
          callApi(setProfileShared(cookies.load('mrktCd'), cookies.load('langCd')));
        } catch (err) {
          console.log(err);
        }
      }
    }
  };
  const timer = useRef(null);
  const [clipboardOpen, setClipboardOpen] = useState(false);
  const handleCopy = () => {
    updateShared();
    copyClipboard(url);
    setClipboardOpen(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      setClipboardOpen(false);
    }, 2000);
  };

  return (
    <MuiModal
      id="prp-share-modal"
      data-testid="share-modal"
      open={open}
    >
      <Box
        minWidth={320}
        maxWidth={isNotMobile ? 568 : 355}
        position="relative"
        top="15%"
        transform="translate(-50%)"
        margin="auto"
      >
        <Paper>
          <Box>
            <Box
              lineHeight="44px"
              mr={language === 'ar' ? 0 : 3.5}
              ml={language === 'ar' ? 3.5 : 0}
              textAlign={language === 'ar' ? 'left' : 'right'}
            >
              <IconButton
                size="small"
                aria-label="close"
                onClick={() => {
                  sessionStorage.removeItem('shareModal');
                  setShareOpen(false);
                }}
                id="prp-submit-modal-close"
                color="secondary"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                  <g fill="none" fillRule="evenodd">
                    <path d="M-6-6h24v24H-6z" />
                    <path fill="#70777F" fillRule="nonzero" d="M1.613.21l.094.083L6 4.585 10.293.293a1 1 0 0 1 1.497 1.32l-.083.094L7.415 6l4.292 4.293a1 1 0 0 1-1.32 1.497l-.094-.083L6 7.415l-4.293 4.292a1 1 0 0 1-1.497-1.32l.083-.094L4.585 6 .293 1.707A1 1 0 0 1 1.613.21z" />
                  </g>
                </svg>
              </IconButton>
            </Box>
            <>
              <Box mb={5} textAlign="center" fontFamily="Montserrat" color="#181818">
                <Typography variant="h2">{shareWithLabel || 'Share with'}</Typography>
              </Box>
              <Box
                mx={25}
                mt={6}
                mb={12}
                className={classes.inlineShareButtons}
                id="inlineShareButtons"
                onClick={updateShared}
              >
                <InlineShareButtons
                  config={{
                    alignment: 'center', // alignment of buttons (left, center, right)
                    color: 'social', // set the color of buttons (social, white)
                    enabled: true, // show/hide buttons (true, false)
                    font_size: 16, // font size for the buttons
                    labels: 'null', // button labels (cta, counts, null)
                    language: 'en', // which language to use (see LANGUAGES)
                    networks: [ // which networks to include (see SHARING NETWORKS)
                      ...inlineShareButtons,
                    ],
                    padding: 12, // padding within buttons (INTEGER)
                    radius: 4, // the corner radius on each button (INTEGER)
                    show_total: false,
                    size: 40, // the size of each button (INTEGER)
                    url, // (defaults to current url)
                  }}
                />
                <InlineFollowButtons config={{
                  action: '', // call to action (STRING)
                  action_enable: true, // show/hide call to action (true, false)
                  action_pos: 'bottom', // position of call to action (left, top, right)
                  alignment: 'center', // alignment of buttons (left, center, right)
                  color: 'social', // set the color of buttons (social, white)
                  enabled: true, // show/hide buttons (true, false)
                  networks: [ // which networks to include (see FOLLOW NETWORKS)
                    ...inlineFollowButtons.map(item => item.type),
                  ],
                  padding: 12, // padding within buttons (INTEGER)
                  profiles: { // social profile links for buttons
                    ...inlineFollowLinks,
                  },
                  radius: 4, // the corner radius on each button (INTEGER)
                  size: 40, // the size of each button (INTEGER)
                  spacing: 8, // the spacing between buttons (INTEGER)
                }}
                />
                <Box className={classes.resetSocialMedias}>
                  {
                    resetSocialMedias.map(({ icon, type, link }) => (
                      <Box
                        component="a"
                        key={`prp-share-social-medial-${type}`}
                        className={classes.styledIcon}
                        target="_blank"
                        href={`${socialIcons[type].prefix}${type === 'email' ? `?body=${url}` : link}`}
                        data-network={type}
                      >
                        <Icon className={classes.styledImg}>
                          {icon}
                          {/* <img
                          src={socialIcons[type].icon}
                          alt={altText}
                          type={type}
                          title={altText}
                          className={classes.styledImg}
                        /> */}
                        </Icon>
                      </Box>
                    ))
                  }
                </Box>
              </Box>
              <Box mb={5} textAlign="center" fontFamily="Montserrat" color="#181818">
                <Typography variant="body1">{orCopyLinkLabel || 'Or copy link'}</Typography>
              </Box>
              <Box style={{
                margin: '18px 60px 0',
                padding: 18,
                height: 60,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                background: '#F6F9F9',
                borderRadius: 4,
              }}
              >
                <Box>
                  <Typography
                    priority="h4"
                    style={{
                      wordBreak: 'break-word',
                    }}
                  >
                    {urlPrefer}
                    <strong>{urlLast}</strong>
                  </Typography>
                </Box>
                <Box
                  style={{
                    cursor: 'pointer',
                    position: 'relative',
                  }}
                  onClick={handleCopy}
                >
                  {copyIcon(theme.palette.colors.corePink)}
                  <Box
                    className={classes.clipboardBox}
                    style={{
                      display: clipboardOpen ? 'flex' : 'none',
                    }}
                  >
                    {copyIcon('#979797')}
                    <Box className={classes.clipboardText}>{copiedToClipboardLabel || 'Copied to clipboard !'}</Box>
                  </Box>
                </Box>
              </Box>
              <Box height={60} />
            </>
          </Box>
        </Paper>
      </Box>
    </MuiModal>
  );
};

ShareModal.propTypes = {
  open: bool,
  callApi: func,
  setShareOpen: func,
  slProfile: object,
  socialList: object,
  sharePRPInfo: object,
};

export default ShareModal;
